
  function readURL(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();

            reader.onload = function (e) {
                $('#preview')
                    .attr('src', e.target.result)
                    .width(150);
            };

            reader.readAsDataURL(input.files[0]);
        }
    }
  
  
  
  $(document).ready(function(){      
    if ($("#giftCard").is(':checked')  ){
        $("#greeting-card-message").show();
    }else{
      	$("#greeting-card-message").hide();
   	}
    
  	$('#giftCard').change(function() {
       if(this.checked) {
            $("#greeting-card-message").show();   	
        } else {
            $("#greeting-card-message").hide();
        }
  	});
    
    
    
    
    
    if ($("#photo").is(':checked')){
        $("#photoDiv").show();
    }else{
      	$("#photoDiv").hide();
   	}
    
  	$('#photo').change(function() {
       if(this.checked) {
            $("#photoDiv").show();   	
        } else { 
            $("#photoDiv").hide();
        }
  	});
    
  });
  
    
  $('#CustomAddToCart').click(function(){
    //setTimeout(function(){ $('#AddToCart').hide(); }, 50);
     
    if ($("#giftCard").is(':checked') && $("#photo").is(':checked')){
    	data = {
          items: [{
          "id": 40136437203102,
          "quantity": 1
        },
          {
          "id": 36270276346014,
          "quantity": 1
        }]
        }
        console.log('both checked');
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          async: false,
          data: data,
          dataType: 'json',
          success: function() {
            console.log('success POST both');
            $('#AddToCart').click();
            //window.location.href = '/cart'; 
          }
        });
    }else if ($("#giftCard").is(':checked')){
    	data = {
          items: [
          {
          "id": 36270276346014,
          "quantity": 1
        }]
        }
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          async: false,
          data: data,
          dataType: 'json',
          success: function() {
             
            $('#AddToCart').click();
            //window.location.href = '/cart'; 
          }
        });
    }else if ($("#photo").is(':checked')){
    	data = {
          items: [
          {
          "id": 40136437203102,
          "quantity": 1
        }]
        }
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          async: false,
          data: data,
          dataType: 'json',
          success: function() {
             
            $('#AddToCart').click();
            //window.location.href = '/cart'; 
          }
        });
    } else{
       
      $('#AddToCart').click();
    }
  });
